module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/6c5d6b7c2a3958980c36b4199bc3878c.png";